import React, { Component } from "react";
import { loading, t } from "../components/CustomComponent.js";
import Logo from "../components/Logo.js";
import { legalContent, loadLegal } from "./legal_content.js";
import { getCompany, loadCompany, subscribeCompany } from "../services/company.service.js";
import FLAG_TH from "../assets/images/thailand.png";
import FLAG_EN from "../assets/images/usd.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
import "../assets/css/policy.css";

/**
 * ข้อกำหนดการใช้งาน — หน้าสาธารณะ เปิดดูได้โดยไม่ต้องล็อกอิน (route /terms-of-use)
 *
 * ใช้โครงหน้าและสไตล์ชุดเดียวกับนโยบายความเป็นส่วนตัว (policy.css) เพราะเป็นเอกสาร
 * ประเภทเดียวกัน — ผู้ใช้ที่เปิดสองหน้านี้ต่อกันจะได้ไม่รู้สึกว่าหลุดไปคนละเว็บ
 * ต่างกันแค่ปุ่มย้อนกลับ : หน้านี้เข้ามาจากฟุตเตอร์เว็บลูกค้า จึงกลับไปหน้าแรก (/)
 *
 * เนื้อหาแก้ได้จากหลังบ้าน (/ad/home/terms) อ่านผ่าน GET home/legal/terms
 * ถ้า API ใช้ไม่ได้จะตกไปใช้เนื้อหาชุดที่ฝังไว้ในโค้ด (terms_option.js) แทน
 * ชื่อบริษัทและช่องทางติดต่อในเอกสารมาจาก "ตั้งค่า › ข้อมูลบริษัท" ผ่าน company.service
 * (ตัวเดียวกับที่เมนูใช้ดึงโลโก้) — อ่านค่าที่ cache ไว้ได้ทันทีตั้งแต่เฟรมแรก
 * แล้ว subscribe ไว้เผื่อ API ตอบกลับมาช้ากว่าที่หน้านี้เปิด
 */
export default class TermsUse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // ใช้คีย์ lang เดียวกับหน้าอื่นทั้งระบบ เพื่อให้ภาษาที่เลือกไว้ต่อเนื่องกัน
      lang: localStorage.getItem("lang") || "TH",
      company: getCompany(),
      data: null,
    };
  }

  async componentDidMount() {
    this.setTitle();
    window.scrollTo({ top: 0 });
    loading(false);

    this.unsubscribeCompany = subscribeCompany((company) => this.setState({ company }, this.setTitle));
    loadCompany(); // ยิงครั้งเดียวต่อการเปิดเว็บ — เรียกซ้ำได้ ตัว service กันไว้ให้แล้ว

    const data = await loadLegal("terms");
    if (data) this.setState({ data }, this.setTitle);
  }

  componentWillUnmount() {
    if (this.unsubscribeCompany) this.unsubscribeCompany();
  }

  content = () => legalContent("terms", this.state.lang, this.state.company, this.state.data);

  setTitle = () => {
    const content = this.content();
    document.title = `${content.title} | ${content.company.brand}`;
  };

  changeLanguage = (newLang) => {
    localStorage.setItem("lang", newLang);
    window.location.reload();
  };

  /* แปลง block หนึ่งก้อนเป็น element — รองรับ p / ul / note / link ชุดเดียวกับหน้านโยบาย */
  renderBlock = (block, index) => {
    if (block.type === "note") {
      return (
        <p className="mn-policy__note" key={index}>
          {block.text}
        </p>
      );
    }

    if (block.type === "link") {
      return (
        <p key={index}>
          <a className="mn-policy__link" href={block.href}>
            {block.text}
          </a>
        </p>
      );
    }

    if (block.type === "ul") {
      return (
        <ul key={index}>
          {block.items.map((item, i) => {
            // เนื้อหาจากไฟล์ในโค้ดเขียนรายการเป็นสตริงเปล่าได้ ส่วนที่มาจาก API เป็น { label, text } เสมอ
            const line = typeof item === "string" ? { label: "", text: item } : item;
            return (
              <li key={i}>
                {!!line.label && <span className="mn-policy__label">{line.label}</span>}
                {line.label && line.text ? " : " : ""}
                {line.text}
              </li>
            );
          })}
        </ul>
      );
    }

    return <p key={index}>{block.text}</p>;
  };

  render() {
    const { lang } = this.state;
    const content = this.content();

    return (
      <div className="mn-policy">
        {/* ============ แถบบน : โลโก้ / ภาษา / กลับหน้าแรก ============ */}
        <div className="mn-policy__topbar">
          <button
            type="button"
            className="mn-policy__brand"
            onClick={() => (window.location.href = "/")}
          >
            <Logo size={38} />
          </button>

          <div className="mn-policy__tools">
            <div className="mn-policy__lang">
              <img
                className="mn-policy__lang-flag"
                src={lang === "EN" ? FLAG_EN : FLAG_TH}
                alt=""
              />
              <select
                className="mn-policy__lang-select"
                value={lang}
                onChange={(e) => this.changeLanguage(e.target.value)}
              >
                <option value="TH">{t("lang_thai")}</option>
                <option value="EN">{t("lang_english")}</option>
              </select>
            </div>

            <a className="mn-policy__back" href="/">
              {t("terms_back")}
            </a>
          </div>
        </div>

        {/* ============ เนื้อหา ============ */}
        <div className="mn-policy__wrap">
          <div className="mn-policy__head">
            <h1 className="mn-policy__title">{content.title}</h1>
            <p className="mn-policy__subtitle">{content.subtitle}</p>
            {!!content.updated && (
              <span className="mn-policy__updated">
                {t("policy_updated")} : {content.updated}
              </span>
            )}
          </div>

          <div className="mn-policy__card">
            <p className="mn-policy__lead">{content.lead}</p>

            {/* สารบัญ — กดแล้วเลื่อนไปยังหัวข้อ (scroll-margin-top กันแถบบนบังไว้แล้ว) */}
            <nav className="mn-policy__toc">
              {content.sections.map((section) => (
                <a key={section.key} href={`#terms-${section.key}`}>
                  {section.title}
                </a>
              ))}
            </nav>

            {content.sections.map((section) => (
              <section
                key={section.key}
                id={`terms-${section.key}`}
                className={`mn-policy__section${
                  section.highlight ? " mn-policy__section--highlight" : ""
                }`}
              >
                <h2 className="mn-policy__section-title">{section.title}</h2>
                {section.blocks.map(this.renderBlock)}
              </section>
            ))}
          </div>

          <div className="mn-policy__footer">
            © {new Date().getFullYear()} {content.company.name} · {t("all_rights_reserved")}
          </div>
        </div>
      </div>
    );
  }
}
